import actions from "@/store/modules/release-access/actions";
import mutations from "@/store/modules/release-access/mutations";
import state from "@/store/modules/release-access/state";

export default {
    actions,
    mutations,
    state
}